/**
 * <strong>Purpose:</strong> <br>
 * Provides the ability to block interaction with the widget. This mixin disables interactivity with the widget
 * by preventing both mouse interactions and tabbing to this widget via the keyboard.
 * <br><br>
 * <strong>Contract:</strong> <br>
 * This mixin is dependent upon: <br>
 * {@link module:mw-form/mixins/property/DisabledMixin}<br>
 *
 * @module MW/toolstrip/mixins/property/GalleryItemDisabledMixin
 *
 * @copyright Copyright 2018 The MathWorks, Inc.
 */

define([
        "dojo/_base/declare",
        "mw-form/mixins/property/DisabledMixin"
    ],
    function (declare, DisabledMixin) {

    var GalleryItemDisabledMixin = declare(null, {
        _setDisabledAttr: function (value, originator) {
            this.inherited(arguments);

            // Only fire Gallery State Changed event when the state is changed from a user interaction
            if (originator && originator.source === "UI") {
                this.galleryStateChanged(true);
            } else {
                this.galleryStateChanged(false);
            }
        },

        //TODO: overriding this function to solve geck g1796571, but this mixin could just go away once g1826112 is completed.
        _addDisableListener: function (domNode, handler) {
            domNode = this._disabledNode ? this._disabledNode : this.domNode;

            this.inherited(arguments);
        }
    });


    GalleryItemDisabledMixin._dependencies = [
        {mixin: DisabledMixin, orderDependent: true}
    ];

    return GalleryItemDisabledMixin;
});